import React from "react";
import Modal from "react-responsive-modal";

const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title = "Are you sure?",
  message,
  cancelText = "Cancel",
  confirmText = "Confirm",
}) => (
  <Modal open={open} onClose={onClose} center>
    <div className="p-4 text-center">
      <h4 className="uk-text-bold mb-3">{title}</h4>
      {message && <p className="mb-4">{message}</p>}
      <div
        className="d-flex justify-content-center"
        style={{ gap: "10px" }}
      >
        <button
          type="button"
          className="uk-button uk-button-default text-uppercase"
          onClick={onClose}
        >
          {cancelText}
        </button>
        <button
          type="button"
          className="uk-button uk-button-default text-uppercase"
          onClick={onConfirm}
        >
          {confirmText}
        </button>
      </div>
    </div>
  </Modal>
);

export default ConfirmModal;
